import {
  NewConfirmDeleteOneModal as LibConfirmDeleteOneModal,
  NewConfirmDeleteOneModalProps as LibConfirmDeleteOneModalProps,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export type ConfirmDeleteOneModalProps = Omit<LibConfirmDeleteOneModalProps, "languageTexts">;

export const ConfirmDeleteOneModal: FC<ConfirmDeleteOneModalProps> = (props) => {
  const t = useT();

  return (
    <LibConfirmDeleteOneModal
      {...props}
      languageTexts={{
        cancel: t("general.actions.cancel"),
        confirmationText: t("component.modal.confirm.delete.message"),
        title: t("component.modal.confirm.delete.heading"),
        close: t("general.actions.close"),
        delete: t("general.actions.delete"),
      }}
    />
  );
};
